export const BLOG_POSTS = [
  {
    slug: 'comprare-casa-nelle-marche-guida-completa',
    categoria: 'Guida Acquisto',
    categoriaEn: 'Buying guide',
    categoriaDe: 'Kaufratgeber',
    data: '15 Marzo 2026',
    dataEn: 'March 15, 2026',
    dataDe: '15. März 2026',
    updatedAt: '4 Maggio 2026',
    updatedAtEn: 'May 4, 2026',
    updatedAtDe: '4. Mai 2026',
    readingTime: '~12 minuti',
    readingTimeEn: '~12 minutes',
    readingTimeDe: '~12 Minuten',
    title: 'Comprare casa nelle Marche: la guida completa per il 2026',
    titleEn: 'Buying a home in Marche: the complete guide for 2026',
    titleDe: 'Ein Haus in den Marken kaufen: der vollständige Leitfaden für 2026',
    excerpt: 'Dalla ricerca dell\'immobile alla firma del rogito: tutto quello che devi sapere per acquistare casa nei borghi marchigiani, passo dopo passo.',
    excerptEn: 'From property search to signing the deed: everything you need to know to buy a home in the Marche borghi, step by step.',
    excerptDe: 'Von der Immobiliensuche bis zur Unterzeichnung der Urkunde: alles, was Sie wissen müssen, um ein Haus in den Marken-Dörfern zu kaufen.',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20traditional%20stone%20country%20house%20nestled%20among%20rolling%20green%20hills%20of%20Marche%20Italy%20with%20terracotta%20roof%20tiles%20surrounded%20by%20olive%20groves%20and%20vineyards%20under%20warm%20golden%20sunlight%2C%20authentic%20Italian%20real%20estate%20investment%20property%20photography%20without%20people&width=800&height=500&seq=blog001v2&orientation=landscape',
    relatedBorghi: ['castelfidardo', 'corinaldo'],
  },
  {
    slug: 'borghi-piu-belli-marche-2026',
    categoria: 'Borghi',
    categoriaEn: 'Borghi',
    categoriaDe: 'Dörfer',
    data: '20 Aprile 2026',
    dataEn: 'April 20, 2026',
    dataDe: '20. April 2026',
    updatedAt: '4 Maggio 2026',
    updatedAtEn: 'May 4, 2026',
    updatedAtDe: '4. Mai 2026',
    readingTime: '~13 minuti',
    readingTimeEn: '~13 minutes',
    readingTimeDe: '~13 Minuten',
    title: 'I 10 borghi più belli delle Marche da scoprire nel 2026',
    titleEn: 'The 10 most beautiful borghi in Marche to discover in 2026',
    titleDe: 'Die 10 schönsten Dörfer der Marken, die man 2026 entdecken sollte',
    excerpt: 'Un viaggio attraverso i borghi medievali più affascinanti della regione: storia, architettura, sapori e immobili da sogno.',
    excerptEn: 'A journey through the most fascinating medieval borghi of the region: history, architecture, flavours and dream properties.',
    excerptDe: 'Eine Reise durch die faszinierendsten mittelalterlichen Dörfer der Region: Geschichte, Architektur, Aromen und Traumimmobilien.',
    image: 'https://readdy.ai/api/search-image?query=Panoramic%20aerial%20view%20of%20Cingoli%20Marche%20Italy%20the%20Balcony%20of%20the%20Marche%20medieval%20hilltop%20borgo%20stone%20buildings%20terracotta%20roofs%20sweeping%20landscape%20view%20over%20green%20rolling%20hills%20and%20distant%20mountains%20under%20clear%20blue%20sky%20golden%20sunlight%20no%20people%20editorial%20travel%20photography&width=800&height=500&seq=blog002v2&orientation=landscape',
    relatedBorghi: ['servigliano', 'offagna'],
  },
  {
    slug: 'vivere-nelle-marche-qualita-vita',
    categoria: 'Stile di vita',
    categoriaEn: 'Lifestyle',
    categoriaDe: 'Lebensstil',
    data: '1 Aprile 2026',
    dataEn: 'April 1, 2026',
    dataDe: '1. April 2026',
    updatedAt: '4 Maggio 2026',
    updatedAtEn: 'May 4, 2026',
    updatedAtDe: '4. Mai 2026',
    readingTime: '~26 minuti',
    readingTimeEn: '~26 minutes',
    readingTimeDe: '~26 Minuten',
    title: 'Vivere nelle Marche: qualità della vita, costi e opportunità',
    titleEn: 'Living in Marche: quality of life, costs and opportunities',
    titleDe: 'Leben in den Marken: Lebensqualität, Kosten und Chancen',
    excerpt: 'Perché sempre più italiani e stranieri scelgono le Marche come nuova casa: dati, storie e consigli pratici.',
    excerptEn: 'Why more and more Italians and foreigners are choosing Marche as their new home: data, stories and practical advice.',
    excerptDe: 'Warum immer mehr Italiener und Ausländer die Marken als neues Zuhause wählen: Daten, Geschichten und praktische Ratschläge.',
    image: 'https://readdy.ai/api/search-image?query=Italian%20lifestyle%20Marche%20countryside%20family%20outdoor%20lunch%20terrace%20vineyard%20olive%20trees%20quality%20of%20life%20authentic%20Italian%20living%20warm%20golden%20sunlight%20editorial%20photography&width=800&height=500&seq=blog003v2&orientation=landscape',
    relatedBorghi: ['castelfidardo', 'numana'],
  },
  {
    slug: 'investire-immobili-marche-2026',
    categoria: 'Investimenti',
    categoriaEn: 'Investments',
    categoriaDe: 'Investitionen',
    data: '22 Febbraio 2026',
    dataEn: 'February 22, 2026',
    dataDe: '22. Februar 2026',
    updatedAt: '5 Maggio 2026',
    updatedAtEn: 'May 5, 2026',
    updatedAtDe: '5. Mai 2026',
    readingTime: '~5 minuti',
    readingTimeEn: '~5 minutes',
    readingTimeDe: '~5 Minuten',
    title: 'Investire in immobili nelle Marche: perché il 2026 è il momento giusto',
    titleEn: 'Investing in Marche real estate: why 2026 is the right time',
    titleDe: 'In Immobilien in den Marken investieren: warum 2026 der richtige Zeitpunkt ist',
    excerpt: 'Analisi del mercato immobiliare marchigiano: prezzi, trend, rendimenti e le zone con maggiore potenziale di crescita.',
    excerptEn: 'Analysis of the Marche real estate market: prices, trends, returns and the areas with the greatest growth potential.',
    excerptDe: 'Analyse des Immobilienmarktes in den Marken: Preise, Trends, Renditen und die Gebiete mit dem größten Wachstumspotenzial.',
    image: 'https://readdy.ai/api/search-image?query=Italian%20real%20estate%20investment%20Marche%20property%20market%20analysis%20growth%20opportunity%20countryside%20villa%20farmhouse%20value%20appreciation&width=800&height=500&seq=blog004&orientation=landscape',
    relatedBorghi: ['offagna', 'mondavio'],
  },
];